module.exports = __webpack_public_path__ + "static/media/business_4.09ed504a.png";